import FactSheetConverter from '@/converters/3.6/FactSheetConverter';
import WorkFileConverter from '@/converters/3.6/WorkFileConverter';
import CompFinalConverter from '@/converters/3.6/CompFinalConverter';
import IComp from '@/models/Comp';
import ICompFinalData from '@/models/comp-final/ICompFinalData';
import CompAddressUtils from '@/models/comp/CompAddressUtils';
import ICompAddress from '@/models/CompAddress';
import FactSheetPropertyUtils from '@/models/fact-sheet/3.6/FactSheetPropertyUtils';
import IFactSheet from '@/models/fact-sheet/3.6/IFactSheet';
import IWorkFile from '@/models/fact-sheet/3.6/IWorkFile';
import IUserSettings from '@/models/IUserSettings';
import { mlsStore, userSettingsStore } from '@/store';
import ProductFeaturesUtils from '@/utils/ProductFeaturesUtils';
import utils from '@/utils/QSUtils';
import _ from 'lodash';
import SalesHistoryManager from './SalesHistoryManager';
import IFactSheetProperty from '@/models/fact-sheet/3.6/IFactSheetProperty';
import ICompFinalProperty from '@/models/comp-final/ICompFinalProperty';

export default {
    /**
     * Create a fact sheet from the given comp, including the sales history.
     * Sales history requires Smart Data be enabled (Product Features) for the user.
     * @param comp
     * @returns
     */
    async createFromComp(comp: IComp): Promise<ICompFinalProperty> {
        // Force inclusion of this comp (bypasses hasVisited/export filtering) and run it through the
        // same convert -> appendAdditionalProperties -> compFinalDataStructure pipeline used for the
        // full export, so sourceData/sourceDataDB/PR/SE/MLS/FF come out in that same nested shape.
        const userSettings: IUserSettings = { ...userSettingsStore.UserSettings!, exportAllComps: true };
        let compFinalData = CompFinalConverter.convert([comp], userSettings);
        compFinalData = CompFinalConverter.appendAdditionalProperties(compFinalData);
        const structuredData = CompFinalConverter.compFinalDataStructure(_.cloneDeep(compFinalData));
        const factSheetProperty: ICompFinalProperty = structuredData.TotalComps[0];

        const smartDataEnabled = ProductFeaturesUtils.isSmartDataEnabled();
        if (smartDataEnabled) {
            // Get any sales history and add it to the fact sheet properties
            await addSalesHistory(factSheetProperty, factSheetProperty.address);
        }

        return factSheetProperty;
    },

    /**
     * Create a work file populated with fact sheet properties, including sales histories, from
     * the given comp final data.
     * Sales histories requires Smart Data be enabled (Product Features) for the user.
     *
     * @param compFinalData
     * @returns
     */
    async createFromCompFinalData(compFinalData: ICompFinalData): Promise<ICompFinalData> {
        let workFile = compFinalData;
        const smartDataEnabled = ProductFeaturesUtils.isSmartDataEnabled();
        if (smartDataEnabled) {
            // Get any sales history and add it to the fact sheet properties
            for (const factSheetProperty of workFile) {
                await addSalesHistory(factSheetProperty, factSheetProperty.address);
            }
        }
            
        return workFile;
    },
};

async function addSalesHistory(factSheetProperty: ICompFinalProperty, compAddress: ICompAddress): Promise<boolean> {
    const salesHistoryProperty = await SalesHistoryManager.getByCompAddress(compAddress);
    if (salesHistoryProperty.salesHistory.length > 0) {
        factSheetProperty.salesHistory = salesHistoryProperty.salesHistory;
        return true;
    }
    return false;
}
